import axios from 'axios';

// Create an Axios instance
const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // URL = base URL + request URL
  // timeout: 10000, // Request timeout in milliseconds
});

// Request interceptor: adds headers before request is sent
service.interceptors.request.use(
  (config) => {
    // Retrieve user data from local storage
    const userDatas = JSON.parse(localStorage.getItem('userDatas'));

    // Set headers if user data and token exist
    if (userDatas && userDatas.token) {
      config.headers.Authorization = `Bearer ${userDatas.token}`;
    }

    // Set other headers as needed
    config.headers['Content-Type'] = 'application/json';
    config.headers.Accept = 'application/json';

    // Log request info for debugging
    console.log('Making request to:', config.url);
    console.log('Headers:', config.headers);

    return config;
  },
  (error) => {
    // Log the error for debugging
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor: handles response data and errors
service.interceptors.response.use(
  (response) => {
    // Return response data
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      const serverMessage = error.response.data && error.response.data.message;
      if (serverMessage) {
        console.log('Server Message:', serverMessage);
      }
      // Handle specific status codes
      if (status === 401) {
        // Handle unauthorized error
        localStorage.clear();
        window.location.href = '/sessionExpired';
      } else if (status === 400) {
        console.error('Server returned status code 400:', data);
        // You can handle specific server error messages here
        return Promise.reject(data); // Reject the promise with server data
      }

      // Add other status code handling as needed
    } else {
      // Handle network errors or unexpected errors
      console.error('Unexpected error:', error);
    }

    // Log the error for debugging
    console.error('Response error:', error);
    return Promise.reject(error);
  }
);

export default service;
